const OuterContainer =  {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	height: '100vh',
	backgroundColor: '#f0f0f0 ',
	
};
export default OuterContainer;
